module.exports = __webpack_public_path__ + "static/media/ola_15dias.838efa81.jpg";